import React, {Fragment} from 'react';
import {OdontoProfessionalSelectionProps} from './types';
import {useOdontoProfessionalSelection} from './hooks/useOdontoProfessionalSelection';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {translations} from 'presentation/translations-new';
import {OdontoProfessionalSelectionNotFoundState} from './components/OdontoProfessionalSelectionNotFoundState';
import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {AlertModal} from 'presentation/components';
import {PendingDialog} from 'presentation/modules/booking/shared/ui/components/PendingDialog';
import {OdontoSelectedDateProfessionalList} from './components/OdontoSelectedDateProfessionalList';
import {OdontoNearestDateProfessionalList} from './components/OdontoNearestDateProfessionalList';

const {bookOdonto} = translations['pt-br'].privateFlow.services;
const {loadingState, loadingError, verifyingAuth, errorModal} =
	translations['pt-br'].privateFlow.bookingFlow.professionalFlow;

export function OdontoProfessionalSelection({handleNextStep}: OdontoProfessionalSelectionProps) {
	const {
		isLoading,
		refetch,
		isError,
		showNotFoundState,
		odontoAddressModal,
		setOdontoAddressModal,
		showSelectedDateProfessionalGrid,
		handleSelectHour,
		handleClearShiftAndSearch,
		availableDates,
	} = useOdontoProfessionalSelection({
		handleNextStep,
	});

	if (isLoading) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookOdonto}
				loadingText={loadingState}
			/>
		);
	}

	if (isError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookOdonto}
				errorTitle={loadingError}
				handleRefresh={refetch}
			/>
		);
	}

	if (showNotFoundState) {
		return (
			<OdontoProfessionalSelectionNotFoundState
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_PROFISSIONAL_DISPONIVEL}
			/>
		);
	}

	return (
		<Fragment>
			{showSelectedDateProfessionalGrid ? (
				<OdontoSelectedDateProfessionalList
					handleSelectHour={handleSelectHour}
					handleClearShiftAndSearch={handleClearShiftAndSearch}
				/>
			) : (
				<OdontoNearestDateProfessionalList
					handleSelectHour={handleSelectHour}
					handleClearShiftAndSearch={handleClearShiftAndSearch}
					availableDates={availableDates ?? []}
				/>
			)}

			<AlertModal
				headerTitle={errorModal.headerTitle}
				title={errorModal.title}
				variant="error"
				description={errorModal.description}
				open={odontoAddressModal === 'error'}
				onClose={() => setOdontoAddressModal('none')}
			/>

			<PendingDialog
				open={odontoAddressModal === 'loading'}
				onClose={() => setOdontoAddressModal('none')}
				text={verifyingAuth}
			/>
		</Fragment>
	);
}
